import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Modal, Backdrop, Fade, Box, Typography, IconButton, Grid, useMediaQuery, useTheme, CircularProgress } from '@mui/material';
import { API_URL } from '../../../apiConfig';

const ActionsPreview = () => {
  const { id } = useParams();
  const theme = useTheme();
  const isSmallerScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedActions, setSelectedActions] = useState({ pdfURL: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActionsById = (id) => {
      axios.get(`${API_URL}/actions/${id}`)
        .then((response) => {
          setSelectedActions(response.data);
        })
        .catch((error) => {
          console.error('Error fetching actions information:', error);
        })
        .finally(() => {
          setLoading(false);
        });
    };
    if (id) {
      fetchActionsById(id);
    }
  }, [id]);

  const getModalWidth = () => {
    return isSmallerScreen ? '90%' : '60%';
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        width: getModalWidth(),
        maxHeight: '90%',
        overflow: 'auto',
        overflowY: 'scroll',
        overflowX: 'hidden',
      }}
    >
      {loading ? (
        <CircularProgress />
      ) : selectedActions.pdfURL ? (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="h4" component="div" gutterBottom sx={{ textTransform: 'uppercase' }}>
                {selectedActions.title}
              </Typography>
              <Typography variant="subtitle1" gutterBottom sx={{ color: 'text.secondary' }}>
                {selectedActions.updatedAt &&
                  new Date(selectedActions.updatedAt).toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'numeric',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                  })}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography variant="body1" gutterBottom sx={{ fontSize: '14px', wordWrap: 'break-word', maxWidth: '100%' }}>
                {selectedActions.longDescription ? (
                  <span dangerouslySetInnerHTML={{ __html: selectedActions.longDescription }} />
                ) : (
                  "No description available"
                )}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {/* Display the first page of the PDF using <embed> */}
              {selectedActions.pdfURL && (
                <embed
                  src={'../' + selectedActions.pdfURL}
                  type="application/pdf"
                  width="100%"
                  height="800"
                />
              )}
            </Grid>
          </Grid>
        </>
      ) : (
        <Typography variant="body1" gutterBottom>
          No actions Found.
        </Typography>
      )}

    </Box>
  );
};

export default ActionsPreview;
